import MdiPackageVariant from '~icons/mdi/package-variant'
import MdiPlay from '~icons/mdi/play'
import MdiWarehouse from '~icons/mdi/warehouse'
import MdiFolderOutline from '~icons/mdi/folder-outline'
import MdiClipboardList from '~icons/mdi/clipboard-list'
import MdiAccountGroup from '~icons/mdi/account-group'
import MdiWrench from '~icons/mdi/wrench'
import MdiChartBar from '~icons/mdi/chart-bar'
import MdiTruck from '~icons/mdi/truck'
import MdiMapMarker from '~icons/mdi/map-marker'
import MdiCubeOutline from '~icons/mdi/cube-outline'
import MdiTag from '~icons/mdi/tag'
import MdiHome from '~icons/mdi/home'
import MdiCog from '~icons/mdi/cog'
import MdiStar from '~icons/mdi/star'
import MdiCalendar from '~icons/mdi/calendar'
import MdiBarcodeScan from '~icons/mdi/barcode-scan'
import MdiSwapHorizontal from '~icons/mdi/swap-horizontal'
import MdiAccount from '~icons/mdi/account'
import MdiCart from '~icons/mdi/cart'
import MdiArchive from '~icons/mdi/archive'
import MdiFlash from '~icons/mdi/flash'

const ICONS = {
  'package-variant': MdiPackageVariant,
  play: MdiPlay,
  warehouse: MdiWarehouse,
  folder: MdiFolderOutline,
  clipboard: MdiClipboardList,
  'account-group': MdiAccountGroup,
  wrench: MdiWrench,
  chart: MdiChartBar,
  truck: MdiTruck,
  marker: MdiMapMarker,
  cube: MdiCubeOutline,
  tag: MdiTag,
  home: MdiHome,
  cog: MdiCog,
  star: MdiStar,
  calendar: MdiCalendar,
  barcode: MdiBarcodeScan,
  swap: MdiSwapHorizontal,
  account: MdiAccount,
  cart: MdiCart,
  archive: MdiArchive,
  flash: MdiFlash,
}

/** Curated icon ids for the edit-modal picker. */
export const FRONTPAGE_ICONS = Object.keys(ICONS).map((id) => ({ id }))

/** Resolve a stored icon token to a Vue component. */
export function resolveFrontpageIcon(raw, { contentType } = {}) {
  if (raw && ICONS[raw]) return ICONS[raw]
  if (contentType === 'macro') return MdiPlay
  if (contentType === 'chart') return MdiChartBar
  if (contentType === 'statistics') return MdiCubeOutline
  return MdiPackageVariant
}
